import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { useNavigate, useParams } from 'react-router';

import { useAppDispatch, useAppSelector } from 'store';
import { IHotelsItem } from 'store/slices/hotels/interfaces';
import {
  bulkUpdateHotelsItem,
  loadHotelsItem,
} from 'store/slices/hotels/actions';
import { serializeSelectPriorityItem } from 'utils/mappings';
import { StatusesEnum } from 'constants/status';
import CardSpin from 'components/Card/CardSpin';
import { IFormProps, SampleEditForm } from 'components/Sample/SampleEditForm';
import { EntitySelect } from 'components/form/AsyncSelect/EntitySelect';
import { urls } from 'store/api';

interface IProps {
  sortFieldName?: keyof Pick<
    IHotelsItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  slug: string;
}

export const Edit: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  slug,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [queryLoading, setQueryLoading] = useState(!!id);
  const data = useAppSelector(state => state.hotels);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const onSubmit = (params: IFormProps<IHotelsItem>) => {
    const data = params.values;
    const prevItem =
      id && Number(id) != data.id
        ? { id: Number(id), [sortFieldName]: null }
        : {};
    const updateElements = [
      {
        id: data.id,
        [sortFieldName]: params.sortPriority,
      },
      prevItem,
    ].filter(el => el.id);
    dispatch(bulkUpdateHotelsItem(updateElements))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно изменена',
        });
        navigate(slug);
      })
      .catch(() => setIsLoading(false));
  };

  const handleCancel = () => {
    navigate(slug);
  };

  const initialValues = serializeSelectPriorityItem({
    values: data.item,
    sortFieldName,
  });

  useEffect(() => {
    if (id) {
      dispatch(loadHotelsItem(id))
        .unwrap()
        .finally(() => {
          setQueryLoading(false);
        });
    }
  }, [id]);

  if (queryLoading) {
    return <CardSpin />;
  }

  const Select = () => (
    <EntitySelect
      name='values'
      label='Отель'
      placeholder='Выберите отель'
      additional={{
        status: StatusesEnum.PUBLISHED,
        sort: `${sortFieldName}`,
      }}
      required
      requestUrl={urls.api.hotels.get}
    />
  );

  return (
    <SampleEditForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      handleCancel={handleCancel}
      isLoading={isLoading}
      select={Select}
    />
  );
};
